/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PartNumberChangesMainPageComponent} from './part-number-changes-main-page.component';
import {TableModule} from '../../shared/table/table.module';
import {PaginationModule} from '../../shared/pagination/pagination.module';
import {CodeFilterModule} from '../../shared/filter/code-filter/code-filter.module';
import {InputAndCodeFilterModule} from '../../shared/filter/input-and-code-filter/input-and-code-filter.module';
import {DateFilterModule} from '../../shared/filter/date-filter/date-filter.module';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';
import {PartNumberChangesDetailModule} from '../part-number-changes-detail/part-number-changes-detail.module';
import {InputFilterModule} from '../../shared/filter/input-filter/input-filter.module';
import {SegmentedButtonModule} from '../../shared/segemented-button/segmented-button.module';
import {ChipInputModule} from '../../shared/chip-input/chip-input.module';
import {NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import {ProxyManagementModule} from '../shared/proxy-management/proxy-management.module';

@NgModule({
    declarations: [PartNumberChangesMainPageComponent],
    imports: [
        CommonModule,
        TableModule,
        PaginationModule,
        CodeFilterModule,
        InputAndCodeFilterModule,
        DateFilterModule,
        InputFilterModule,
        LoadingSpinnerModule,
        PartNumberChangesDetailModule,
        SegmentedButtonModule,
        ChipInputModule,
        NgbTypeaheadModule,
        ProxyManagementModule
    ],
    exports: [PartNumberChangesMainPageComponent]
})
export class PartNumberChangesMainPageModule {
}
